/** 业务协同 **/

import Layout from '@/views/layout/Layout'

const processMan = {
  path: '/processMan',
  name: '业务协同',
  component: Layout,
  // redirect: '/dataDic/departMan',
  // component: () => import('@/views/dataDic/index'),
  meta: {
    title: '业务协同',
    icon: 'nested',
    roles: ['liuchengguanli']
  },
  alwaysShow: true,
  children: [
    // 提报
    {
      path: 'tibaoMatter',
      component: () => import('@/views/processMan/tibaoMatter'),
      name: '提报事项',
      meta: {
        title: '提报事项',
        roles: ['tibaoshixiang']
      }
    },
    // 待办
    {
      path: 'daibanMatter',
      component: () => import('@/views/processMan/daibanMatter'),
      name: '待办事项',
      meta: {
        title: '待办事项',
        roles: ['daibanshixiang']
      }
    },
    {
      path: 'supplyChainTodoMatter',
      component: () => import('@/views/processMan/supplyChainTodoMatter'),
      name: '供应链待办事项',
      meta: {
        title: '供应链待办事项',
        roles: ['daibanshixiang']
      },
      hidden: true,
    },
    // 待发
    {
      path: 'daifaMatter',
      component: () => import('@/views/processMan/daifaMatter'),
      name: '待发事项',
      meta: {
        title: '待发事项',
        roles: ['daifashixiang']
      }
    },
    // 已发
    {
      path: 'yifaMatter',
      component: () => import('@/views/processMan/yifaMatter'),
      name: '已发事项',
      meta: {
        title: '已发事项',
        roles: ['yifashixiang']
      }
    },

    // 已办
    {
      path: 'yibanMatter',
      component: () => import('@/views/processMan/yibanMatter'),
      name: '已办事项',
      meta: {
        title: '已办事项',
        roles: ['yibanshixiang']
      }
    },
    // 知会
    {
      path: 'zhihuiMatter',
      component: () => import('@/views/processMan/zhihuiMatter'),
      name: '知会事项',
      meta: {
        title: '知会事项',
        roles: ['zhihuishixiang']
      }
    },
    // 终止
    {
      path: 'zhongzhiMatter',
      component: () => import('@/views/processMan/zhongzhiMatter'),
      name: '终止事项',
      meta: {
        title: '终止事项',
        roles: ['zhihuishixiang']
      }
    },
    // 事项列表
    {
      path: 'shixiangList',
      component: () => import('@/views/processMan/shixiangList'),
      name: '事项列表',
      meta: {
        title: '事项列表',
        roles: ['shixiangliebiao']
      }
    },
    // 待办列表
    {
      path: 'daibanList',
      component: () => import('@/views/processMan/daibanList'),
      name: '待办列表',
      meta: {
        title: '待办列表',
        roles: ['act_daibanliebiao']
      }
    },
    // 创建流程模型
    {
      path: 'createProcessModel',
      component: () => import('@/views/processMan/createProcessModel/index'),
      name: '创建流程模型',
      meta: {
        title: '创建流程模型',
        roles: ['chuangjianliuchengmoxing']
      }
    },
    // 操作指引配置
    {
      path: 'operationConfiguration',
      component: () => import('@/views/processMan/operationConfiguration'),
      name: '操作指引配置',
      meta: {
        title: '操作指引配置',
        roles: ['caozuozhiyinpeizhi']
      }
    }
  ]
}

export default processMan
